import { ComponentPropsWithoutRef, ReactNode, Ref, forwardRef } from 'react';
import { cx } from '@linaria/atomic';
import { NakedButton, Heading, CaretDownIconSmall } from '@frontend/design-system';
import { buttonStyle, headingStyle, caretStyle, caretOpenStyle } from './page-title-menu.styles';

type Props = { children: ReactNode; isOpen: boolean } & ComponentPropsWithoutRef<'button'>;

export const PageTitleMenuButton = forwardRef((props: Props, ref: Ref<HTMLButtonElement>) => {
  const { children, isOpen, className, ...rest } = props;
  return (
    <NakedButton className={cx(buttonStyle, className)} ref={ref} {...rest}>
      <Heading level={1} className={headingStyle}>
        {children}
      </Heading>
      <CaretDownIconSmall className={cx(caretStyle, isOpen && caretOpenStyle)} />
    </NakedButton>
  );
});
